export default __webpack_public_path__ + "static/app-store-btn-mobile-3a1f82ab77c6afb7439211025667219c.svg";